import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/panda/css';
import { type HTMLStyledProps, styled } from '@repo/panda/jsx';
import { type TypeVariantProps, type } from '@repo/panda/recipes';
import type { SystemProperties } from '@repo/panda/types';
import type React from 'react';
export type TypeProps<E extends React.ElementType = 'p'> = TypeVariantProps & Omit<HTMLStyledProps<E>, 'as' | 'color'> & {
  className?: string;
  color?: SystemProperties['color'];
  as?: E;
};
const StyledType = styled.p;
export function Type<E extends React.ElementType = 'p'>(props: TypeProps<E>): React.JSX.Element;
export function Type(t0) {
  const $ = _c(20);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      truncate: t1,
      className,
      color: t2,
      as: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = variant;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    variant = $[6];
  }
  const truncate = t1 === undefined ? false : t1;
  const color = t2 === undefined ? undefined : t2;
  const as = t3 === undefined ? "p" : t3;
  let T0;
  let t4;
  let t5;
  if ($[7] !== as || $[8] !== className || $[9] !== color || $[10] !== truncate || $[11] !== variant) {
    const colorClass = css({
      color
    });
    T0 = StyledType;
    t4 = as;
    t5 = cx(type({
      variant,
      truncate
    }), colorClass, className);
    $[7] = as;
    $[8] = className;
    $[9] = color;
    $[10] = truncate;
    $[11] = variant;
    $[12] = T0;
    $[13] = t4;
    $[14] = t5;
  } else {
    T0 = $[12];
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[15] !== T0 || $[16] !== props || $[17] !== t4 || $[18] !== t5) {
    t6 = <T0 as={t4} className={t5} {...props} />;
    $[15] = T0;
    $[16] = props;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}